import { isArray } from 'util';

import { mapCollection, sortByString } from '../../utils/collection.utils';
import { Article } from '../article';
import { ArticleCamBuilder } from './article-cam.builder';

export class ArticleBuilder {
  static fromJson(json) {
    return (json)
      ? new Article(
        json.hash,
        json.articleNumber,
        json.description,
        json.routeDescription,
        json.extendedDescription,
        ArticleCamBuilder.fromJson(json.cam),
        json.hasSpecialTool
      )
      : null;
  }

  static fromList(list) {
    return isArray(list) ?
      sortByString('articleNumber', mapCollection(ArticleBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/article.builder.ts